import axiosOD from '../../axios/axiosOD';
import * as actions from './index';
import SnackBarType from '../../objects/app/snackbar';
import { Dispatch } from 'redux';
import { Method } from 'axios';

const logResponseFailAndDisplayItInSnackbar = (
    url: string,
    method: Method,
    error: any,
    dispatch: Dispatch,
    errors: any = {}
) => {
    // Logger.error(`Request to url "${url}" with method ${method} failed with status code "${response.status}".`);
    let errMsg = error;
    if (errors && errors[error]) {
        errMsg = errors[error];
    }
    dispatch(actions.addSnackbar(errMsg, SnackBarType.ERROR, false));
};

const isSuccessfulResponse = (response: any) =>
    [200, 201, 206].indexOf(response.status) !== -1 &&
    response.data.success === true;

export const handleRequest = async (
    url: string,
    dispatch: Dispatch,
    actionType: any,
    dataConverter: any = null,
    method: Method = 'get',
    params = {},
    data = {},
    headers = {},
    responseConverter: any = null,
    onSuccess = () => {},
    errors: any = {}
) => {
    dispatch({ type: actionType.start });
    // const method = methodParam.toLowerCase();
    try {
        const response = await axiosOD(url, {
            method,
            params,
            data,
            headers,
        });
        if (isSuccessfulResponse(response)) {
            let dispatchObject: any = {
                type: actionType.success,
                data:
                    dataConverter === null
                        ? response.data.data
                        : dataConverter(response.data.data),
            };

            if (responseConverter !== null) {
                dispatchObject.response = responseConverter(response);
            }

            if (response.data.allCount) {
                dispatchObject.allCount = response.data.allCount;
            }

            dispatch(dispatchObject);
            onSuccess();
        } else {
            let errorMsg = '';
            if (response.data.errors) {
                if (Array.isArray(response.data.errors)) {
                    errorMsg += response.data.errors.join('<br />');
                } else {
                    errorMsg += 'Unspecified error.';
                }
            }
            logResponseFailAndDisplayItInSnackbar(
                url,
                method,
                errorMsg,
                dispatch,
                errors
            );
            dispatch({ type: actionType.fail });
        }
    } catch (error: any) {
        logResponseFailAndDisplayItInSnackbar(
            url,
            method,
            error.message,
            dispatch,
            errors
        );
        dispatch({ type: actionType.fail });
    }
    return null;
};
